import { MutableRefObject, useRef } from 'react';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import { CustomButton, CustomSelect, Text } from '../../shared/uiComponents';
import { intervalData, selectTimeList } from './constants';
import { generateFilename, saveCanvas } from './utils';
import { GraphControlsPanelProps } from './types';
import './graph.scss';

const GraphControlsPanel = ({
	activeInterval,
	selectValue,
	onIntervalChange,
	onSelectChange,
	clientName,
	itemName,
	graphType,
	annotationsList,
}: GraphControlsPanelProps) => {
	const reportTemplateRef = useRef() as MutableRefObject<HTMLDivElement>;

	const handleGeneratePdf = () => {
		const document = new jsPDF({
			format: 'a4',
			unit: 'px',
		});

		document.html(reportTemplateRef.current, {
			callback: (doc) => doc.save(generateFilename(clientName, itemName)),
		});
	};

	const handleDownload = () => {
		const fileName = generateFilename(clientName, itemName);
		saveCanvas(fileName);
		handleGeneratePdf();
	};

	return (
		<>
			<div className="graphControlsContainer">
				<div className="graphFilterBlock">
					<CustomButton title="Download" onClick={handleDownload} buttonType="tertiary" className="graphFilterButton" />
					{intervalData.map((interval, i) => (
						<div key={i} className="graphFilterWrapper">
							<button
								className={`graphFilterButton ${activeInterval === interval.id ? 'graphFilterButtonActive' : ''}`}
								onClick={() => onIntervalChange(interval.id)}
							>
								{interval.id}
							</button>
						</div>
					))}
				</div>
				<CustomSelect data={selectTimeList} value={selectValue} setValue={(e) => onSelectChange(e.target.value)} />
			</div>

			<div className="graphPdfHidden">
				<div ref={reportTemplateRef}>
					<div className="graphPdfContent">
						<Text title="Annotations description" type="h3" className="graphPdfHeader" />
						<div className="graphPdfSubtitle">
							<Text title={`Client Name: ${clientName}`} type="psm" />
						</div>
						<div className="graphPdfSubtitle">
							<Text title={`${graphType === 'target' ? 'Target Name' : 'Behavior Name'}: ${itemName}`} type="psm" />
						</div>
						<div className="graphPdfListWrapper">
							<div className="graphPdfTitleRow">
								<Text title="Description" type="pxs" fontWeight="bold" />
								<Text title="Date" type="pxs" fontWeight="bold" />
							</div>
							<div>
								{annotationsList?.map((item) => (
									<div key={item.id} className="graphPdfDataRow">
										<Text title={item.note} type="pxs" />
										<Text title={dayjs(new Date(item.date)).format('MM-DD-YYYY')} type="pxs" />
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default GraphControlsPanel;
